"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var UserSettingsForm_1 = __importDefault(require("@/Components/UserSettings/UserSettingsForm"));
var react_i18next_1 = require("react-i18next");
var Tab_1 = __importDefault(require("@/Components/common/Tab"));
var BrowserSessions_1 = __importDefault(require("@/Components/UserSettings/BrowserSessions"));
var TwoFactorAuthentication_1 = __importDefault(require("@/Components/UserSettings/TwoFactorAuthentication"));
var UserSettingsForm_module_css_1 = __importDefault(require("./UserSettingsForm.module.css"));
var UserSettingsComponent = function () {
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var _a = (0, react_1.useState)("profile"), active = _a[0], setActive = _a[1];
    return (react_1.default.createElement("div", { className: UserSettingsForm_module_css_1.default.contentContainer },
        react_1.default.createElement("div", { className: UserSettingsForm_module_css_1.default.tabs },
            react_1.default.createElement(Tab_1.default, { value: "profile", onClick: function () { return setActive("profile"); }, text: t("Profile"), active: active === "profile" })),
        active === "profile" ? react_1.default.createElement(UserSettingsForm_1.default, null)
            : active === "browserSessions" ? react_1.default.createElement(BrowserSessions_1.default, null)
                : active === "twoFactorAuthentication" ? react_1.default.createElement(TwoFactorAuthentication_1.default, null)
                    : react_1.default.createElement(react_1.default.Fragment, null)));
};
exports.default = UserSettingsComponent;
